<template>
  <div :class="boxMsgStyle">
    <div ref="icon_bot" class="bot-icon" v-if="!isUserSend">
        <img :src="styles.avatarBot" alt="robot" style="max-width:24px;max-height:24px;">
    </div>
    <v-container class="text-box-button pa-0 ma-0" fluid>
      <v-row no-gutters>

        <v-spacer v-if="isUserSend"></v-spacer>
        <v-col xs="12" sm="8" md="5" lg="3" xl="2">
          <div class="image-box-content">
            <div class="image-display">
              <a :href="msgFileUrl" target="_blank">
                <v-img :src="msgFileUrl" aspect-ratio="1.333" cover v-if="fileIsImage(msgFileUrl)" />
                <div class="fileDownload" v-else>
                  <v-icon>mdi-file-download</v-icon>
                </div>
                <div class="fileName" :title="fileName">{{fileName}}</div>
              </a>

            </div>
            <buttonReact :message_id="msgId" :user_act="msgReact" v-if="!isUserSend"></buttonReact>
          </div>

        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import buttonReact from './react-button.vue'
import BaseBox from "@/components/ChatBoxElement/BaseBox";
export default {
  name: 'fileBox',
  extends: BaseBox,
  props: {
    isUserSend: false,
    isFirstMsg: false,
    isLastMsg: false,
    content: null,
    msgId     : '',     // message id
    msgReact  : '',
  },
  components: {
    buttonReact
  },
  data() {
    return {
      msgFileUrl: '',
      fileName: '',
      iconBotCustom: ''
    }
  },
  mounted() {
    // console.log(this.content);
    let jContent = {};
    if (typeof(this.content) === 'string') {
      jContent = JSON.parse(this.content);
    } else {
      jContent = this.content;
    }

    if (jContent) {
      this.msgFileUrl = jContent['url']
      // fix file name has plus
      if (this.msgFileUrl.indexOf(`+`) > -1) {
        this.msgFileUrl = this.msgFileUrl.replace(/\+/g, '%2B');
      }

      this.fileName = this.getFileNameFromUrl(this.msgFileUrl);
    }

    this.iconBotCustom = this.$store.state.bot_icon;
    if (this.iconBotCustom !== '' && !this.isUserSend) {
      console.log(this.$refs);
      this.$refs.icon_bot.setAttribute('style', 'background-image: url(\'' + decodeURIComponent(this.iconBotCustom) + '\'');
    }

  },
  methods: {
    fileIsImage(fileName) {
      if (fileName) {
        let ext = fileName.split('.').pop().toLowerCase();
        let imageExt = ['tif', 'png', 'gif', 'ico', 'jpg', 'jpeg'];
        return imageExt.indexOf(ext) >= 0;
      }
      return false
    },

    getFileNameFromUrl(url) {
      let name = url.split('/').pop();
      return decodeURI(name);
    }
  },
  computed: {
    boxMsgStyle() {
      let st = "box-msg"
      if (this.isFirstMsg) {
        st = st + " first-box-msg"
      }
      if (this.isLastMsg) {
        st = st + " last-box-msg"
      }
      return st
    },
  }
}
</script>

<style scoped>
  .image-display {
    border: 1px solid lightgray;
    border-radius: 5px;
    width: 100%;
    min-height: 100px;
    position: relative;
    overflow: hidden;
  }

  .bot-icon {
    width: 40px;
    height: 50px;
    float: left;
    background-size: 32px;
  }

  .fileDownload {
    height: 100%;
    min-height: 100px;
    text-align: center;
  }

  .fileDownload i {
    font-size: 47px;
    margin-top: 20px;
  }
  .fileName {
    display: block;
    padding: 2px 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    background: rgb(0, 0, 0,0.5);
    color: #fff;
    position: absolute;
    bottom: 0;
}
</style>
